import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import HelpModal from './modals/Help';
import StatsModal from './modals/Stats';
import SettingsModal from './modals/Settings';
import { Icon } from '@mui/material';

export default function NavBar() {
    const [showHelp, setShowHelp] = React.useState(false);
    const [showStats, setShowStats] = React.useState(false);
    const [showSettings, setShowSettings] = React.useState(false);

    return (
        <AppBar position="static" sx={{display: 'flex', justifyContent: 'center', width: '100%'}}>
            <Toolbar>
            <img src="logo512.png" alt="logo" className="logo" />
            <Typography variant="h6" component="div">
                athlee
            </Typography>
            <Box flexGrow={1}/>
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="settings"
                sx={{ mr: 1 }}
                onClick={()=>{setShowHelp(!showHelp)}}
            >
                <HelpOutlineOutlinedIcon />
            </IconButton>
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="stats"
                sx={{ mr: 1}}
                onClick={()=>{setShowStats(!showStats)}}
            >
                <LeaderboardOutlinedIcon />
            </IconButton>
            {/* <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="settings"
                sx={{ mr: 1 }}
                onClick={()=>{setShowSettings(!showSettings)}}
            >
                <SettingsOutlinedIcon />
            </IconButton>   */}
            </Toolbar>
            <HelpModal showModal={showHelp} onClose={() => setShowHelp(false)} />
            <StatsModal showModal={showStats} onClose={() => setShowStats(false)} />
            {/* <SettingsModal showModal={showSettings} onClose={()=> setShowSettings(false)} /> */}
        </AppBar>
    );
}